import api from "./api";

const measurementService = {
  async getAll(params = {}) {
    try {
      const response = await api.get("/measurements", { params });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async getById(id) {
    try {
      const response = await api.get(`/measurements/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async create(measurementData) {
    try {
      const response = await api.post("/measurements", measurementData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async update(id, measurementData) {
    try {
      const response = await api.put(`/measurements/${id}`, measurementData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async delete(id) {
    try {
      const response = await api.delete(`/measurements/${id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async toggleStatus(id) {
    try {
      const response = await api.patch(`/measurements/${id}/toggle-status`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default measurementService;
